import React, { Component } from 'react';
import Mapping from './Mapping.js';
import ViewMapping from './viewMapping';
import {Tabs, Tab, Spinner} from 'react-bootstrap';
import { connect } from 'react-redux';
import {AuditorListAction, AgentListSearch, mapAgentsAction, SupervisorSearch, closeModalPopUp, ReAssignAgents, MappedAgentsListView} from './agentAuditorAction';
import ShowModalPopUp from '../ShowModalPopUp';
import _ from 'lodash'

class Mapindex extends Component {	
  constructor(props){
    super(props)
    this.state={
      key : 'HOME_QA'
    }
  }
	componentDidMount(){		
    
  }
  UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEqual(nextProps.showModalLogin, this.props.showModalLogin) && nextProps.showModalLogin === false){     
    }
  }
  loadTabContent = (prop) => {
    this.setState({key:prop})
  }   
  ScreensComp = () =>{        
    const{auditorList, size, agentList, supervisor, loginAction, mappedAgentList} = this.props;    
    const{key} = this.state
    if(!_.isEmpty(loginAction)){
    let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "AGENT_MAPPING"})   
    let returnObj =[]
    _.map(moduleAccess.screens, (obj) =>{ 
        if(obj.screenUId === "HOME_QA"){ 
          let accessPermission = obj.accessPermission
          returnObj.push(<Tab eventKey="HOME_QA" title="MAP AGENTS" key={1}>            
            <Mapping size={size} action={this.props} agentList={agentList} accessPermission={accessPermission} auditorList={auditorList} supervisor={supervisor} />           
          </Tab>)}
        if(obj.screenUId === "VIEW_QA"){ 
          returnObj.push(<Tab eventKey="VIEW_QA" title="VIEW AGENTS" key={2}>          
            <ViewMapping action={this.props} accessPermission={obj.accessPermission} size={size} auditorList={auditorList} mappedAgentList={mappedAgentList}/> 
          </Tab>)}
       
      })
    returnObj =	_.sortBy(returnObj, ['key'])
   return (<Tabs defaultActiveKey={ moduleAccess.screens[0].screenUId} transition={false} activeKey={key ? key : returnObj[0].props.eventKey} unmountOnExit={true}
   id="noanim-tab-example" onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
   {returnObj}</Tabs>)
    }
     
  } 
  render(){
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }
    return(
    	<div className={(style) ? 'user' : "userSmall"}>
       {this.props.isPending ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}    
       {(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
        falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
      {this.ScreensComp()}
    </div>)
  }
}
function mapStateToProps(state){
  return{
    auditorList:  state.agentAuditorReducer.auditorList, 
    agentList:  state.agentAuditorReducer.agentList, 
    isPending:  state.agentAuditorReducer.isPending, 
    showerror:  state.agentAuditorReducer.showerror,
    errmessage:  state.agentAuditorReducer.errmessage, 
    size: state.UserReducer.large,    
    loginAction: state.LoginReducer.loginAction,
    supervisor: state.agentAuditorReducer.supervisor,
    showModalLogin: state.UserReducer.showModalLogin,
    mappedAgentList : state.agentAuditorReducer.mappedAgentList,
  }  
}

const mapDispatchToProps = (dispatch) => ({
  AuditorListAction:  (a) =>dispatch(AuditorListAction(a)),
  AgentListSearch:  (a) =>dispatch(AgentListSearch(a)),
  mapAgents:  (a) =>dispatch(mapAgentsAction(a)), 
  SupervisorSearch: (a) =>dispatch(SupervisorSearch(a)),
  closeModalPopUp:  (a) =>dispatch(closeModalPopUp(a)), 
  ReAssignAgents: (a) => dispatch(ReAssignAgents(a)),
  MappedAgentsListView: (a) => dispatch(MappedAgentsListView(a))
})

export default connect(mapStateToProps, mapDispatchToProps)(Mapindex);
